import React from 'react';

import { HighlightedSpan } from '@/shared/components/ui/highlighted-text/highlighted-text.styled';
import { THighlightedTextProps } from '@/shared/components/ui/highlighted-text/highlighted-text.types';

export const HighlightedText: React.FC<THighlightedTextProps> = ({
  text,
  searchTerm,
}) => {
  const getParts = () => {
    const parts = text
      .toLowerCase()
      .split(searchTerm.toLowerCase())
      .reduce<string[]>((acc, part, index) => {
        if (index === 0) {
          return [...acc, part];
        }
        return [...acc, searchTerm, part];
      }, []);

    return parts.map((part, index) => {
      const lengthOfPreviousParts = parts
        .slice(0, index)
        .reduce((acc, curr) => acc + curr.length, 0);

      return text.slice(
        lengthOfPreviousParts,
        lengthOfPreviousParts + part.length,
      );
    });
  };

  if (!searchTerm) {
    return text;
  }

  return getParts().map((part, index) => (
    <HighlightedSpan
      key={index}
      $isHighlighted={part.toLowerCase() === searchTerm.toLowerCase()}
    >
      {part}
    </HighlightedSpan>
  ));
};
